(function($) {
    $(function() {
        $('#about-box-footer--button').click(function() {
            $('.about-box .js-output-card .search-bar-results-block')
                .find('.edit-icon')
                .each(function() {
                    $(this).toggle();
                });
            $(this).addClass('visible-print');
            $('#about-box-footer--cancel').removeClass('visible-print');
        });

        $('#about-box-footer--cancel').click(function() {
            $('.about-box .js-output-card .search-bar-results-block')
                .find('.edit-icon')
                .each(function() {
                    $(this).toggle();
                });
            $(this).addClass('visible-print');
            $('#about-box-footer--button').removeClass('visible-print');
        });

        $(document).on('click', '.edit-icon', function() {
            const deceasedId = $(this).data('id');
            $('#feedback-modal').data('id', deceasedId);
        });

        $(document).on('input', '#feedback-modal--email', function() {
            $('.feedback-modal--error-text').html('');
        });
        
        $(document).on('input', '#feedback-modal--textarea', function() {
            $('.feedback-modal--body-error-text').html('');
        });

        $(document).on('click', '#feedback-modal--submit', function(e) {
            e.preventDefault();
            const deceasedId = parseInt($('#feedback-modal').data('id'), 10);
            const feedbackModal = $('#feedback-modal');
            const emailError = $('.feedback-modal--error-text');
            const emailBodyError = $('.feedback-modal--body-error-text');

            if (!deceasedId) {
                return;
            }

            const feedbackForm = $('.js-feedback-form');
            const [email, body] = feedbackForm.serializeArray().map(e => e.value);

            const emailValidationRegex = /^[A-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Z0-9.-]+$/gi;

            let error = false;
            if (!emailValidationRegex.test(email)) {
                emailError.html('Hibás e-mail cím.');
                error = true;
            } else {
                emailError.html('');
            }

            if (typeof body !== 'string' || !body?.trim()) {
                emailBodyError.html('A visszajelzés kitöltése kötelező.');
                error = true;
            } else {
                emailBodyError.html('');
            }

            if (error) {
                return;
            }

            $.ajax({
                url: `/api/feedback`,
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify({
                    email,
                    body,
                    deceasedId,
                }),
                error: function(error) {
                    $('#feedback-modal--email').val('');
                    $('#feedback-modal--textarea').val('');
                    feedbackModal.iziModal('close');
                    $('#error-modal').iziModal(
                        'setTitle',
                        error.responseJSON?.message || 'Hiba a kérés teljesítése során'
                    );
                    $('#error-modal').iziModal('open');
                    $('.about-box .js-output-card .search-bar-results-block')
                        .find('.edit-icon')
                        .each(function() {
                            $(this).toggle();
                        });
                    resetSuggestionButtons();
                },
                success: function() {
                    $('#feedback-modal--email').val('');
                    $('#feedback-modal--textarea').val('');
                    feedbackModal.iziModal('close');
                    $('#success-modal').iziModal(
                        'setTitle',
                        'Sikeres visszajelzés. Köszönjük a hozzájárulását!'
                    );
                    $('#success-modal').iziModal('open');
                    $('.about-box .js-output-card .search-bar-results-block')
                        .find('.edit-icon')
                        .each(function() {
                            $(this).toggle();
                        });
                    resetSuggestionButtons();
                },
            });
        });
    });
})(jQuery);
